import React, { Component } from "react";
import Image from "../../assets/img/familyStories.png";
import {Link} from 'react-router-dom';


// const red = {
//   color: "red"
// };

const Btn = {
  backgroundColor: "#65cdf0",
  border: "none",
  color: "#ffffff",
  //   padding: '10px 25px',
  textAlign: "center",
  textDecoration: "none",
  display: "inline-block",
  fontSize: "15px",
  borderRadius: "25px",
  marginLeft: "55%",
  padding: "5px 9px 8px 10px",
  //   fontWeight: '600',
};

class StoryCard extends Component {
  render() {
    return (
      <div>
        <div className='container-fluid'>
          <div className='card mb-3 mt-3'>
            <div className='row no-gutters'>
              <div className='col-md-4'>
                <img src={Image} className='card-img' alt="" />
              </div>
              <div className='col-md-8'>
                <div className='card-body'>
                  <h5 className='card-title' >
                    Dependant's story
                     {/* {this.props.link} */}
                  {/* {this.props.name} */}
                    </h5>
                  <p className='card-text'>
                    {/* {this.props.story} */}
                    {this.props.shortstory}
                  </p>
                  <p className='footer'>
                    
                      <i className='fab fa-youtube fa-2x'></i>
                   
                      {/* <a href={this.props.link}>
                      Read More
                      </a> */}
                      <Link to ={`/dependantstories/person/${this.props.link}`} > 
                    <button className='btn-primary btn-xs' style={Btn}>
                        read More
                    </button>
                      </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default StoryCard;
